import { useEffect, useState } from "react";
import "./chapter-item.css";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import {
  PiReadCvLogoDuotone,
  PiClockCountdownDuotone,
  PiLockKeyDuotone,
} from "react-icons/pi";
import { VscDebugStart } from "react-icons/vsc";
import {
  capitalizeAll,
  convertDuration,
  isEmpty,
} from "../../../../core/utils/helpers";

const ChapterItem = ({
  type,
  chapter,
  selectedChapterId,
  selectedLessonId,
  onSelectLesson,
  forceOpenChapterId,
}) => {
  const [isChapterDetails, setIsChapterDetails] = useState(false);

  const chapter_id = chapter?.id;
  const chapter_title = capitalizeAll(chapter?.title);
  const chapter_description = chapter?.description;
  const lessons = chapter?.lessons;
  const timing = chapter?.timing || chapter?.chapter_timing || 0;

  // Forcer l'ouverture si forceOpenChapterId correspond à ce chapitre
  useEffect(() => {
    if (forceOpenChapterId === chapter.id) {
      setIsChapterDetails(true);
    }
  }, [forceOpenChapterId, chapter.id]);

  return (
    <div className="chapter-item">
      <div
        className={`ch-i-header ${selectedChapterId === chapter_id ? "is_selected" : ""}`}
        onClick={() => setIsChapterDetails((prev) => !prev)}
      >
        <div className="ch-i-h-l">
          <h1>{chapter_title}</h1>
          <div className="d-flex gap-md">
            <div className="tile">
              <PiReadCvLogoDuotone className="icon" />
              <span>
                {lessons?.length + " "}
                {lessons?.length > 1 ? "lessons" : "lesson"}
              </span>
            </div>
            <div className="tile">
              <PiClockCountdownDuotone className="icon" />
              <span>{convertDuration(timing)}</span>
            </div>
          </div>
        </div>
        <div className="ch-i-h-r">
          {isChapterDetails ? (
            <IoIosArrowUp className="icon" />
          ) : (
            <IoIosArrowDown className="icon" />
          )}
        </div>
      </div>
      {isChapterDetails && (
        <div className="ch-i-content">
          <p className="chapter-resume mt-xs mb-xs">{chapter_description}</p>
          <div className="chapter-lessons">
            {isEmpty(lessons) ? (
              <div className="w-full p-md">
                <p
                  style={{
                    color: "brown",
                    fontStyle: "italic",
                    fontSize: "0.8rem",
                  }}
                >
                  No lesson available yet for this chapter!
                </p>
              </div>
            ) : (
              lessons?.map((lesson) => (
                <div
                  className={`lesson-item ${
                    selectedLessonId === lesson.id ? "is_selected" : ""
                  }`}
                  key={lesson.id}
                  onClick={() => {
                    if (type !== "preview") {
                      if (lesson?.is_locked) return;
                      onSelectLesson(chapter.id, lesson);
                    }
                  }}
                >
                  {lesson?.is_locked ? (
                    <PiLockKeyDuotone className="icon is-locked" />
                  ) : (
                    <VscDebugStart className="icon" />
                  )}
                  <div className="les-it-col">
                    <h2>{capitalizeAll(lesson?.title)}</h2>
                    <div className="d-flex align-center">
                      <PiClockCountdownDuotone className="icon" />
                      <span>{convertDuration(lesson?.timing)}</span>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChapterItem;
